export default `



            ██      ██
            ██      ██


          █            █
           ██        ██
             ████████

`